import { getCookieConsentValue } from "react-cookie-consent"

export const onRouteUpdate = ({ location, prevLocation }, pluginOptions) => {
  if (process.env.NODE_ENV === "production" || window.dev === true) {
    if (!window._paq) return

    const { _paq } = window
    if (_paq && getCookieConsentValue() === "true") {
      _paq.push(["setConsentGiven"])
      _paq.push(["setCookieConsentGiven"])
    }
  }

  return null
}
